// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}
/* chart parts */

.layout {
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
}

.chart-module_wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.chartComponentWrapper {
  width: 100%;
}
.floating-tooltip-2 {
  width: 108px;
  position: absolute;
  top: 10em;
  padding: 8px;
  box-sizing: border-box;
  font-size: 12px;
  background-color: white;
  z-index: 1000;
  pointer-events: none;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 1px 3px 0px #ababab66;
}
.floating-tooltip-2 p {
  font-size: small;
  font-weight: bolder;
}

.select-wrapper {
  margin-top: 10px;
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  padding: 10px 0px;
  margin: 0;
}

.select-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  padding: 4px;
  color: #76787A;
  font-weight: 400;
  margin: 0 10px;
}
.pagination-link.is-current {
  background-color: #485fc7;
  border-color: #485fc7;
  color: #fff;
}
.pagination-link {
  border-color: #dbdbdb;
  color: #363636;
  min-width: 2.5em;
  font-size: 1em;
  justify-content: center;
  margin: 0.25rem;
  padding-left: 0.5em;
  padding-right: 0.5em;
  text-align: center;
  -webkit-appearance: none;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 0.375em;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.5em;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.5em - 1px);
  padding-left: calc(0.75em - 1px);
  padding-right: calc(0.75em - 1px);
  padding-top: calc(0.5em - 1px);
  position: relative;
  vertical-align: top;
}

/* loder */

.loader-flex {
  height: 50%;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.noDataImg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.noDataImg img {
  width: 40%;
}

.go-to-realtime-button {
  width: 27px;
  height: 27px;
  position: absolute;
  display: none;
  padding: 7px;
  box-sizing: border-box;
  font-size: 10px;
  border-radius: 50%;
  text-align: center;
  z-index: 1000;
  color: #b2b5be;
  background: rgba(250, 250, 250, 0.95);
  box-shadow: 0 2px 5px 0 rgba(117, 134, 150, 0.45);
}
.chart-icon {
  width: 16px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;AACA,gBAAgB;;AAEhB;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;EACjC,gCAAgC;EAChC,iCAAiC;EACjC,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,qCAAqC;EACrC,iDAAiD;AACnD;AACA;EACE,WAAW;AACb","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\n/* chart parts */\n\n.layout {\n  width: 100vw;\n  height: 100vh;\n  background-color: #ffffff;\n}\n\n.chart-module_wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n.chartComponentWrapper {\n  width: 100%;\n}\n.floating-tooltip-2 {\n  width: 108px;\n  position: absolute;\n  top: 10em;\n  padding: 8px;\n  box-sizing: border-box;\n  font-size: 12px;\n  background-color: white;\n  z-index: 1000;\n  pointer-events: none;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  box-shadow: 0px 1px 3px 0px #ababab66;\n}\n.floating-tooltip-2 p {\n  font-size: small;\n  font-weight: bolder;\n}\n\n.select-wrapper {\n  margin-top: 10px;\n  width: 100%;\n  height: 30px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  background-color: transparent;\n  padding: 10px 0px;\n  margin: 0;\n}\n\n.select-bar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 4px;\n  color: #76787A;\n  font-weight: 400;\n  margin: 0 10px;\n}\n.pagination-link.is-current {\n  background-color: #485fc7;\n  border-color: #485fc7;\n  color: #fff;\n}\n.pagination-link {\n  border-color: #dbdbdb;\n  color: #363636;\n  min-width: 2.5em;\n  font-size: 1em;\n  justify-content: center;\n  margin: 0.25rem;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  text-align: center;\n  -webkit-appearance: none;\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: 0.375em;\n  box-shadow: none;\n  display: inline-flex;\n  font-size: 1rem;\n  height: 2.5em;\n  justify-content: flex-start;\n  line-height: 1.5;\n  padding-bottom: calc(0.5em - 1px);\n  padding-left: calc(0.75em - 1px);\n  padding-right: calc(0.75em - 1px);\n  padding-top: calc(0.5em - 1px);\n  position: relative;\n  vertical-align: top;\n}\n\n/* loder */\n\n.loader-flex {\n  height: 50%;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.noDataImg {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.noDataImg img {\n  width: 40%;\n}\n\n.go-to-realtime-button {\n  width: 27px;\n  height: 27px;\n  position: absolute;\n  display: none;\n  padding: 7px;\n  box-sizing: border-box;\n  font-size: 10px;\n  border-radius: 50%;\n  text-align: center;\n  z-index: 1000;\n  color: #b2b5be;\n  background: rgba(250, 250, 250, 0.95);\n  box-shadow: 0 2px 5px 0 rgba(117, 134, 150, 0.45);\n}\n.chart-icon {\n  width: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
